"use client"
import { Icon } from '@iconify/react'
import useHttp from '@/hooks/useHttp';
import { AuthContext } from '@/contexts/auth-context';
import useInfiniteScroll from '@/hooks/useInfiniteScroll';
import React, { useState, useEffect, useContext } from 'react'

import { Close } from '@mui/icons-material'
import { Box, Alert, Button, Dialog, IconButton, Typography, DialogTitle, DialogContent, CircularProgress } from '@mui/material'

import ModalLogin from './modal-login';
import ModalTopBuyers from './modal-top-buyers';
import PaymentItem from '../payment/payment-item';

export default function ModalMyTicketsThirty({
    open,
    onClose,
    showMyTickets,
    setShowMyTickets,
    raffle,
    layoutVariant = "default"
}) {
    const { user } = useContext(AuthContext);
    const [showTopBuyers, setShowTopBuyers] = useState(false);
    const [showTopBuyersDaily, setShowTopBuyersDaily] = useState(false);

    return <>
        <Button variant="contained" color="secondary" fullWidth size='small' onClick={() => setShowMyTickets(true)} style={{
            backgroundImage: 'linear-gradient(90deg, rgb(0, 0, 0), rgb(44, 44, 44))',
            borderRadius: 0
        }}>
            <Icon fontWeight={"bold"} icon={"teenyicons:bag-alt-outline"} />&nbsp; Meus títulos
        </Button>
        {
            raffle?.show_top_general_buyers &&
            <>
                <Button variant="contained" color="success" fullWidth sx={{ mt: 2 }} onClick={() => setShowTopBuyers(true)}> <Icon fontWeight={"bold"} icon={"prime:trophy"} fontSize={20} />&nbsp; Top compradores</Button>
                <ModalTopBuyers open={showTopBuyers} raffle={raffle} onClose={() => setShowTopBuyers(false)} />
            </>
        }

        {
            raffle?.show_top_daily_buyers &&
            <>
                <Button variant="contained" color="success" fullWidth sx={{ mt: 2 }} onClick={() => setShowTopBuyersDaily(true)}> <Icon fontWeight={"bold"} icon={"prime:trophy"} fontSize={20} />&nbsp; Top compradores Diário</Button>
                <ModalTopBuyers showDaily={true} open={showTopBuyersDaily} raffle={raffle} onClose={() => setShowTopBuyersDaily(false)} />
            </>
        }
        {
            open &&
            <DefaultLayout
                user={user}
                showMyTickets={showMyTickets}
                setShowMyTickets={setShowMyTickets}
                showTopBuyers={showTopBuyers}
                setShowTopBuyers={setShowTopBuyers}
                showTopBuyersDaily={showTopBuyersDaily}
                setShowTopBuyersDaily={setShowTopBuyersDaily}
                raffle={raffle}
                layoutVariant={layoutVariant}
                onClose={onClose}
                open={open}

            />
        }
    </>
}


const DefaultLayout = ({ user, setShowMyTickets, showTopBuyers, setShowTopBuyers, raffle, onClose, open, showTopBuyersDaily, setShowTopBuyersDaily }) => {
    const { get, loading } = useHttp();
    const [page, setPage] = useState(0);
    const [paymentsResponse, setPaymentsResponse] = useState(null);
    const [payments, setPayments] = useState(null);

    const getPayments = async () => {
        let response = await get(`/api/payment?page=${page}`, {}, false);

        setPaymentsResponse(response.payments);

        if (Array.isArray(payments)) {
            setPayments([...payments, ...response?.payments.data]);
        } else {
            setPayments(response?.payments.data);
        }

        setPage(page + 1)
    }

    const infiniteRef = useInfiniteScroll({
        loading,
        hasNextPage: true,
        onLoadMore: getPayments,
        rootMargin: '0px 0px 40px 0px',
    });

    useEffect(() => {
        if (!open || !user) {
            return;
        }
        getPayments();
    }, [open]);

    return (
        <>
            {
                !user ?
                    <ModalLogin open={open} onClose={() => setShowMyTickets(false)} />
                    :
                    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                        <DialogTitle >
                            <Box display="flex" alignItems="center" justifyContent={"center"} alignContent={"center"} >
                                <Box flexGrow={1} display="flex" gap={1} alignItems="center" justifyContent={"flex-start"}><Icon icon="teenyicons:bag-alt-outline" /> <Typography fontWeight={600} variant='h5' >Meus títulos</Typography></Box>
                                <Box>
                                    <IconButton onClick={onClose}>
                                        <Close />
                                    </IconButton>
                                </Box>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            {
                                payments?.length && payments.map((item, index) => {
                                    return (
                                        <PaymentItem
                                            key={index}
                                            image={item.image_path}
                                            quantity={item.quantity}
                                            value={item.value}
                                            title={item.title}
                                            status={item.status}
                                            date={item.created_at}
                                            identifier={item.identifier}
                                        />
                                    );
                                })
                            }
                            {
                                (Array.isArray(payments) && payments.length == 0) &&
                                <Alert variant='outlined' severity='warning'>Você ainda não tem títulos</Alert>
                            }
                            {
                                (paymentsResponse && paymentsResponse.current_page != paymentsResponse.last_page) &&
                                <Box sx={{ display: "flex", justifyContent: "center", alignitems: "center" }}>
                                    <CircularProgress
                                        size={30}
                                        ref={infiniteRef}
                                    />
                                </Box>
                            }
                        </DialogContent>
                    </Dialog>
            }
        </>
    );
}
